<template>
	<van-collapse v-model="activeNames">
		<van-collapse-item title="1.什么是钱包？" name="1">钱包是商户所有资金流向的汇总。商户可以查看所有账单，同时也可以进行提现。</van-collapse-item>
		<van-collapse-item title="2.可提现金额？" name="2">商户可以提现的金额上限。</van-collapse-item>
		<van-collapse-item title="3.提现流程和到账时间？" name="3">商户发起提现之后，资金会冻结在冻结账户中，待银行处理完成后自动释放。整个过程等待时间一般不超过10秒。</van-collapse-item>
		<van-collapse-item title="4.提现规则和提现手续费？" name="4">发起提现至少1元钱，提现时不收取手续费。</van-collapse-item>
		<van-collapse-item title="5.待结算金额？" name="5">订单尚未结算之前，收益会统计在待结算金额中，商家此时无法提现。</van-collapse-item>
		<van-collapse-item title="6.待结算金额何时结算？如何提现？" name="6">
			<p>商家自营商品订单在用户确认收货，订单变更为已完成状态时，会自行结算。</p>
			<p>云货架商品订单在每个月27日会结算上个月的所有佣金收入，由于单量过大，结算时间可能会有1日左右延迟。</p>
			<p>待结算金额变更为可提现金额时，便可以直接提现。</p>
		</van-collapse-item>
		<van-collapse-item title="7.钱包总额？" name="7">钱包总额=可提现金额+冻结金额。</van-collapse-item>
		<van-collapse-item title="8.为什么我的实际收入比客户支付的金额少？" name="8">客户支付时，扣除了支付费率，所以实际到账会比客户支付金额少。</van-collapse-item>
		<van-collapse-item title="9.支付费率是多少？" name="9">目前所有线上交易的支付费率为0.45%收款码收款的支付费率为0.3%因系统原因，可能存在更新延迟，若实际费率存在偏差，请于您的客户经理沟通。</van-collapse-item>
		<van-collapse-item title="10.累计收益？" name="10">累计收益指您从开通店铺后所有实际收益的总和。</van-collapse-item>
		<van-collapse-item title="11.今日收益是什么？" name="11">今日收益包括：今日所有待结算订单的实际收入+待结算的云货架佣金+线下收款(扣除支付费率)+会员佣金。</van-collapse-item>
		<van-collapse-item title="12.总收益？" name="12">筛选时间段内所有的收益。</van-collapse-item>
	</van-collapse>
</template>
<script>
import { ref } from 'vue';
import { Collapse, CollapseItem } from 'vant';

export default {
	components: {
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem
	},
	setup() {
		const activeNames = ref([]);
		return { activeNames };
	}
};
</script>
